// All user-facing strings in one place (German, informal "du" as in the GRÜNE tools).

export const T = {
  launcher: 'Feedback',
  launcherLabel: 'Feedback geben: Fehler melden oder Idee vorschlagen',
  launcherClose: 'Feedback-Fenster schließen',
  minimize: 'Feedback-Button einklappen',
  restore: 'Feedback-Button ausklappen',
  title: 'Feedback geben',
  close: 'Schließen',
  back: 'Zurück',

  toolDetected: 'Meldung zu',
  toolProvider: (provider: string) => `betreut von ${provider}`,
  toolChange: 'ändern',
  toolSelectLabel: 'Für welches Tool ist deine Meldung?',
  toolUnknown: 'Weiß ich nicht / anderes Tool',
  recipient: (label: string) => `Deine Meldung geht an: ${label}`,

  blockedTitle: 'Noch nicht freigeschaltet',
  blockedText: 'Diese Seite ist noch nicht für Meldungen freigeschaltet.',
  blockedContact: (label: string) => `Für Fehler und Ideen wende dich bitte direkt an: ${label}`,

  chooseBug: 'Fehler melden',
  chooseBugHint: 'Etwas funktioniert nicht oder sieht falsch aus.',
  chooseFeature: 'Idee vorschlagen',
  chooseFeatureHint: 'Verbesserung oder neue Funktion wünschen.',
  help: (tool: string) => `Hilfe & Anleitungen zu ${tool}`,

  messageLabel: { bug: 'Was ist passiert?', feature: 'Was wünschst du dir?' },
  messageHint: {
    bug: 'Was wolltest du tun? Was ist stattdessen passiert? Gab es eine Fehlermeldung?',
    feature: 'Was möchtest du erreichen und was würde dir dabei helfen?',
  },
  messageTooShort: 'Bitte beschreibe dein Anliegen in ein paar Worten.',

  attachments: { bug: 'Zeigen, wo es hakt', feature: 'Zeigen, worum es geht' },
  screenshotToggle: 'Screenshot der Seite mitsenden',
  screenshotWorking: 'Screenshot wird erstellt …',
  screenshotReady: 'Screenshot erstellt.',
  screenshotFailed: 'Der Screenshot konnte nicht automatisch erstellt werden.',
  screenshotDisplay: 'Bildschirmfoto über den Browser aufnehmen',
  screenshotDisplayHint: 'Dein Browser fragt gleich, was aufgenommen werden darf. Wähle diesen Tab.',
  screenshotEdit: 'Bearbeiten',
  screenshotEditLabel: 'Screenshot bearbeiten: Stellen markieren oder schwärzen',
  screenshotRetake: 'Neu aufnehmen',
  screenshotPreviewAlt: 'Vorschau des Screenshots',

  pickStart: 'Stelle auf der Seite markieren',
  pickMore: 'Weitere Stelle markieren',
  pickBanner: {
    bug: 'Klicke auf die Stelle, an der der Fehler auftritt. Du kannst bis zu 5 Stellen markieren.',
    feature: 'Klicke auf die Stelle, die deine Idee betrifft. Du kannst bis zu 5 Stellen markieren.',
  },
  pickCount: (n: number) => (n === 1 ? '1 Stelle markiert' : `${n} Stellen markiert`),
  pickDone: 'Fertig',
  pickCancel: 'Abbrechen',
  pickBarDown: 'Leiste nach unten verschieben',
  pickBarUp: 'Leiste nach oben verschieben',
  pickRemove: (label: string) => `Markierung „${label}“ entfernen`,
  pickLimit: 'Du hast die maximale Anzahl an Markierungen erreicht.',

  editorTitle: 'Screenshot bearbeiten',
  editorHint: 'Ziehe ein Rechteck auf, um eine Stelle zu markieren oder persönliche Daten zu schwärzen.',
  editorMark: 'Markieren',
  editorRedact: 'Schwärzen',
  editorUndo: 'Rückgängig',
  editorDone: 'Übernehmen',

  contactLabel: 'E-Mail für Rückfragen (optional)',
  contactHint: 'Wird nur genutzt, um Rückfragen zu dieser Meldung zu stellen.',
  contactInvalid: 'Bitte gib eine gültige E-Mail-Adresse an oder lass das Feld leer.',

  detailsSummary: 'Welche technischen Infos werden mitgesendet?',
  detailsPage: 'Seite',
  detailsBrowser: 'Browser',
  detailsWindow: 'Fenstergröße',
  detailsLanguage: 'Sprache',
  detailsErrors: 'JavaScript-Fehler',
  detailsNoErrors: 'keine',
  detailsExtra: 'Zusatzinfos der Anwendung',

  submit: 'Meldung senden',
  sending: 'Wird gesendet …',
  privacy: 'Datenschutz',
  networkError: 'Die Meldung konnte nicht gesendet werden. Bitte prüfe deine Internetverbindung und versuche es erneut.',
  copyHint: 'Dein Text bleibt hier stehen. Zur Sicherheit kannst du ihn kopieren.',
  copyText: 'Text kopieren',
  copied: 'Text kopiert',
  copyFailed: 'Kopieren hat nicht geklappt. Dein Text ist im Feld markiert – kopiere ihn bitte selbst (Strg+C bzw. ⌘+C).',

  successTitle: 'Danke für deine Meldung!',
  successText: (label: string) => `Sie ist bei ${label} angekommen.`,
  successId: 'Vorgangsnummer',
  successCopy: 'Kopieren',
  successCopied: 'Kopiert',
  successNew: 'Neue Meldung',
  successClose: 'Schließen',

  announceOpen: 'Feedback-Fenster geöffnet',
} as const;
